import { initializeSelectCheckers } from './components/select-checker'
import { initializeExclusiveOffersList } from './components/exclusive-offers-list'
import { initializeShowroomCarousels } from './components/exclusive-offers-showroom'
import { initializeCarousels } from './components/carousel'

document.addEventListener('DOMContentLoaded', () => {

  initializeSelectCheckers()
  initializeExclusiveOffersList()
  initializeShowroomCarousels()
  initializeCarousels()
})
